import React from 'react';
import { PromptGroup, RecordDocuments } from 'types/candidateStories';
import { SearchRecord } from 'types/record';
import { CandidateStoryItemTitle } from '../../../../Common';
import PromptSummaryItemsList from './Common/PromptSummaryItemsList';
import PromptSummaryFileList from './Common/PromptSummaryFileList';

const PromptSummaryRecordSection = ({
  recordResponses,
  selectedRecords,
  promptGroups,
  recordDocuments,
}: {
  recordResponses: Record<string, any>;
  selectedRecords: SearchRecord[];
  promptGroups: PromptGroup[];
  recordDocuments: RecordDocuments;
}) => {
  const allKeys = [
    ...Object.keys(recordResponses ?? {}),
    ...Object.keys(recordDocuments ?? {}),
  ];

  const keysMap = allKeys.map(recordId => [
    recordId,
    recordResponses[recordId] ?? {},
  ]);

  const completeRecordResponses = Object.fromEntries(keysMap);
  const totalRecords = Object.entries(completeRecordResponses).length;

  if (allKeys.length === 0) {
    return null;
  }

  return (
    <div
      className='cans-item-wrapper'
      data-testid='prompt-summary-record-section'
    >
      {Object.entries(completeRecordResponses).map(
        ([recordId, recordData], index) => {
          const report = selectedRecords.find(record => record.id === recordId);
          const recordDocumentData = recordDocuments?.[recordId] || {};
          const showDivider = index < totalRecords - 1;

          return (
            <div
              key={recordId}
              className='mb-4'
              data-testid={`prompt-summary-record-section-item-${recordId}`}
            >
              <h5 className='mb-3'>
                <CandidateStoryItemTitle record={report} />
              </h5>
              <PromptSummaryItemsList
                promptResponses={recordData as Record<string, string>}
                recordId={recordId}
                promptGroups={promptGroups}
              />
              <PromptSummaryFileList
                documents={recordDocumentData}
                promptGroups={promptGroups}
                recordId={recordId}
              />
              {showDivider && (
                <hr
                  data-testid='record-section-divider'
                  style={{ marginTop: '1.75rem', marginBottom: '1.75rem' }}
                />
              )}
            </div>
          );
        },
      )}
    </div>
  );
};

export default PromptSummaryRecordSection;
